import Constants from '@/constants/const';

export const ACCOUNT_AUTH_GOOGLE_SOURCE_STORAGE_KEY = 'accountAuthGoogleSource';
export const ACCOUNT_AUTH_FB_SOURCE_STORAGE_KEY = 'accountAuthFbSource';
export const ACCOUNT_AUTH_GOOGLE_SOURCE_FLOW_KEY = 'accountAuthGoogleSourceFlow';
export const ACCOUNT_AUTH_FB_SOURCE_FLOW_KEY = 'accountAuthFbSourceFlow';

const ACCOUNT_AUTH_PATH_SET = new Set(['/account/login', '/account/signup']);

const normalizePathname = (pathname = ''): string => {
  if (!pathname) return '';
  const noLangPath = pathname.replace(Constants.LANGUAGE_REGEXP, '');
  return noLangPath.replace(/\/+$/, '') || '/';
};

export const isAccountAuthPagePath = (pathname = ''): boolean => {
  return ACCOUNT_AUTH_PATH_SET.has(normalizePathname(pathname));
};

export const getAccountAuthSource = (source: unknown, pathname = ''): string | undefined => {
  if (!isAccountAuthPagePath(pathname)) {
    return undefined;
  }
  if (typeof source !== 'string') {
    return undefined;
  }
  const trimmed = source.trim();
  return trimmed || undefined;
};
